import React, { useState, useEffect } from 'react';

interface TypewriterProps {
  Text: string[];
  delay: number;
  infinite: boolean;
}

const Typewriter: React.FC<TypewriterProps> = ({ Text, delay, infinite }) => {
  const [currentText, setCurrentText] = useState('');
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (Text.length === 0) return;

    const currentWord = Text[currentTextIndex];
    let timer: NodeJS.Timeout;

    if (!isDeleting && currentText === currentWord) {
      // Word fully typed, pause before deleting
      timer = setTimeout(() => {
        setIsDeleting(true);
      }, delay * 5); // pause duration (e.g. 1500ms if delay is 300)
    } else if (isDeleting && currentText === '') {
      // Word fully deleted, transition to next word
      setIsDeleting(false);
      const nextIndex = currentTextIndex + 1;
      if (nextIndex < Text.length) {
        setCurrentTextIndex(nextIndex);
      } else if (infinite) {
        setCurrentTextIndex(0);
      }
    } else if (isDeleting) {
      // Deleting character by character
      timer = setTimeout(() => {
        setCurrentText((prev) => prev.slice(0, -1));
      }, delay / 2);
    } else {
      // Typing character by character
      timer = setTimeout(() => {
        setCurrentText((prev) => currentWord.slice(0, prev.length + 1));
      }, delay);
    }

    return () => clearTimeout(timer);
  }, [currentText, isDeleting, currentTextIndex, Text, delay, infinite]);

  return <span className="typewriter">{currentText}</span>;
};

export default Typewriter;
